jQuery(function($){
  var $video = $('#video'),
      $container = $('.video-container'),
      $title = $('.video-title', $container),
      $load = $('.load-more',$container),
      $list = $('.videos-list',$container),
      $items = $('.video-item', $container);

  $items.on('click', function(e){
    e.preventDefault();
    var a = $('a',this);
    $video.attr('src', a.attr('href') + '?autoplay=1');
    $title.text(a.attr('title'))
  });

  $list.mCustomScrollbar({
    scrollInertia: 0
  });

  $items.find('strong').each(function(){
    $clamp(this,{clamp: 2});
  });

  $load.click(function(){
    var elems = $items.filter('.hidden').filter(':lt(5)');
    elems.css('opacity',0).removeClass('hidden').animate({opacity: 1});
    if($items.filter('.hidden').length == 0){
      $load.remove();
    }
  });
});